// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"d67d862b","453":"9a56639c","627":"aa2bd902","738":"3413fe7e","923":"699e24fa"}[chunkId] + ".chunk.js";
};